import { gql } from '@apollo/client';

export const RESEND_EMAIL_MUTATION = gql`
  mutation sendOnboardingEmail($input: SendOnboardingEmailInput) {
    sendOnboardingEmail(input: $input) {
      id
    }
  }
`;
